// extracted by mini-css-extract-plugin
export var closeButton = "_mb-1";
export var closeX = "_mb-3";
export var container = "_mb-0";
export var image = "_mb-2";